// extracted by mini-css-extract-plugin
export default {"legalPage":"CMSPage_legalPage__vGE89"};